import Select from './src/select.mjs';
export { selectV2InjectionKey } from './src/token.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElSelectV2 = withInstall(Select);

export { ElSelectV2, ElSelectV2 as default };
//# sourceMappingURL=index.mjs.map
